import graphql__5c7fa098a6dbd2d65947 from "./__generated__/PageSectionText_pageSection.graphql.js";import { useCallback, useEffect, useRef, useState } from "react";
import { graphql, useFragment } from "react-relay";

import ContainerWithSidebar from "../Sidebar/ContainerWithSidebar";
import ExcerptableContainer from "../Utils/ExcerptableContainer";
import RichText from "../Utils/RichText";

const PageSectionText = props => {
  const pageSection = useFragment(PageSectionText_pageSection, props.pageSection);

  const { sidebar, collapsible, content, columnsRatio, columnsOrder } = pageSection;

  const containerRef = useRef();

  const [collapsedHeight, setCollapsedHeight] = useState(0);

  const processExcerptableContainerHeight = useCallback(() => {
    if (!containerRef.current) return;

    const sidebarElement =
      containerRef.current.querySelectorAll(".two-cols-right-bar")[0];

    const excerptPaddingContainer = containerRef.current.querySelectorAll(
      ".excerpt-padding-container"
    )[0];

    if (!excerptPaddingContainer) return;

    let sidebarHeight = 0;

    if (sidebarElement?.children?.length) {
      const sidebarChildren = Array.from(sidebarElement.children);

      const sidebarChildrenHeight = sidebarChildren.reduce(
        (totalHeight, el) => totalHeight + el.offsetHeight,
        0
      );

      const sidebarChildrenMargins = 10 * (sidebarChildren.length - 1);
      sidebarHeight = sidebarChildrenHeight + sidebarChildrenMargins;
    }

    // Get padding from excerptPaddingContainer to calculate the target height of the
    // inner content of the excerptable container that would match the size of the
    // sidebar minus the padding.
    const containerStyle = window.getComputedStyle(excerptPaddingContainer);
    const topPadding = parseInt(containerStyle.getPropertyValue("padding-top"));
    const bottomPadding = parseInt(containerStyle.getPropertyValue("padding-bottom"));
    const blockYMargins = topPadding + bottomPadding;

    const sidebarCollapseHeight = sidebarHeight - blockYMargins;
    const configuredCollapsedHeight = pageSection.collapsedHeight;

    const newCollapsedHeight = Math.max(sidebarCollapseHeight, configuredCollapsedHeight);

    setCollapsedHeight(newCollapsedHeight);
  }, [pageSection.collapsedHeight]);

  useEffect(() => {
    window.addEventListener("resize", processExcerptableContainerHeight);
    processExcerptableContainerHeight();

    return () => {
      window.removeEventListener("resize", processExcerptableContainerHeight);
    };
  }, [processExcerptableContainerHeight]);

  return (
    <div className="container page-section page-section-text" ref={containerRef}>
      <ContainerWithSidebar {...{ sidebar, columnsRatio, columnsOrder }}>
        <ExcerptableContainer
          className="box excerpt-padding-container padding-md"
          collapsible={collapsible}
          collapsedHeight={collapsedHeight}
        >
          <RichText content={content} />
        </ExcerptableContainer>
      </ContainerWithSidebar>
    </div>
  );
};

const PageSectionText_pageSection = graphql__5c7fa098a6dbd2d65947;

export default PageSectionText;
